export default "__VITE_ASSET__DOhOrkJ5__"